import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { useMcpSession } from '../hooks/useMcpSession';
import { useHost } from '../contexts/HostContext';
import { getOfficeAppVariable } from '../lib/host-adapters';
const McpSessionContext = createContext({
    sessionId: null,
    deviceId: '',
    connectionStatus: null,
    connectionError: null,
});
export function McpSessionProvider({ children }) {
    const { sessionId, deviceId, connectionStatus, connectionError } = useMcpSession();
    const value = useMemo(() => ({ sessionId, deviceId, connectionStatus, connectionError }), [sessionId, deviceId, connectionStatus, connectionError]);
    return _jsx(McpSessionContext.Provider, { value: value, children: children });
}
export function useMcpSessionId() {
    return useContext(McpSessionContext).sessionId;
}
export function useMcpConnectionStatus() {
    return useContext(McpSessionContext).connectionStatus;
}
export function useMcpConnectionError() {
    return useContext(McpSessionContext).connectionError;
}
/**
 * Returns the pipeline-execution variables the Airia backend expects for every
 * Office add-in request: the compute-device identity (when the SignalR hub
 * connection is live) plus the office-app variable. Use this at every call
 * site that builds a `variables: {}` payload so the shape stays consistent.
 *
 * The `omni-compute-device` value is the persistent `deviceId` — not the
 * SignalR connection id. Gated on `sessionId` so we only advertise the device
 * when a hub connection is actually live.
 */
export function useBrowserAgentVariables() {
    const { sessionId, deviceId } = useContext(McpSessionContext);
    const { hostType } = useHost();
    return useMemo(() => ({
        ...(sessionId && deviceId && { 'omni-compute-device': deviceId }),
        ...getOfficeAppVariable(hostType),
    }), [sessionId, deviceId, hostType]);
}
